<template>
  <div class="answers">
    <div
      v-for="(correction, index) in correctionsByAges"
      v-on:click="clicked(index)"
      v-bind:class="{ active: getActive(index) }"
      v-bind:key="index"
      class="age-button"
    >
      {{ correction.message }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive: Number,
    };
  },
  methods: {
    clicked(index) {
      this.$store.dispatch('setMonoCheck', { step: this.step, index: index });
    },

    getActive(index) {
      return this.$store.getters.getMonoCheck(this.step) === index;
    },
  },
  props: {
    correctionsByAges: {
      type: Array,
      required: true,
    },
    step: {
      type: Number,
      required: true,
    },
  },
  name: 'AgeStep',
};
</script>

<style scoped>
.age-button {
  padding: 1em;
  background: white;
  margin-right: 2%;
  cursor: pointer;
  white-space: nowrap;
  font-size: 1.2vw;
}
.answers {
  display: flex;
}
.active.active.active, /* Force .active priority */
.age-button:hover {
  background-color: #5e6a71;
  color: white;
}
.age-button:hover {
  background-color: #afb1a1;
}
</style>
